import { useEffect, useState } from "react";
import { Link2, Linkedin, Twitter } from "lucide-react";
import { toast } from "sonner";

export const ReadingProgress = () => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const el = document.documentElement;
      const max = el.scrollHeight - el.clientHeight;
      setPct(max > 0 ? Math.min(100, (el.scrollTop / max) * 100) : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div aria-hidden className="fixed inset-x-0 top-0 z-[60] h-1 bg-transparent">
      <div className="h-full bg-primary transition-[width] duration-100" style={{ width: `${pct}%` }} />
    </div>
  );
};

export const ShareButtons = ({ url, title }: { url: string; title: string }) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(title);
  const cls =
    "inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground hover:border-primary/40 hover:text-primary transition-colors";
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied");
    } catch {
      toast.error("Could not copy link");
    }
  };
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-muted-foreground mr-1">Share</span>
      <a className={cls} aria-label="Share on LinkedIn" target="_blank" rel="noopener noreferrer"
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${u}`}
        onClick={async (e) => {
          const isMobile = window.matchMedia("(pointer: coarse)").matches;
          if (!isMobile || typeof navigator.share !== "function") return;
          e.preventDefault();
          try {
            await navigator.share({ title, url });
          } catch (err) {
            if ((err as Error)?.name !== "AbortError") {
              window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${u}`, "_blank", "noopener,noreferrer");
            }
          }
        }}>
        <Linkedin className="h-4 w-4" />
      </a>
      <a className={cls} aria-label="Share on X" target="_blank" rel="noopener noreferrer"
        href={`https://twitter.com/intent/tweet?url=${u}&text=${t}`}>
        <Twitter className="h-4 w-4" />
      </a>
      <button type="button" className={cls} aria-label="Copy link" onClick={copy}>
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
};
